import { dropStatusDocumento } from 'utils/drops';

const getContratosFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'contrato',
    label: 'Contrato',
    initial: true,
  },
  {
    name: 'vldocto',
    label: 'Valor',
    type: 'currency',
  },
  {
    name: 'dia_pagto',
    label: 'Dia de Pagamento',
  },
  {
    name: 'forma_pagto',
    label: 'Forma de Pagamento',
    type: 'select',
    options: drops?.FormaDePagamento?.filter(
      (f) => f?.modulo !== 'COMPRAS' && f?.modulo !== 'CHEQUES'
    ),
    multiple: true,
  },
  {
    name: 'ultimo_faturamento.i',
    column: 'ultimo_faturamento',
    label: 'Último Faturamento Inicial',
    type: 'date',
  },
  {
    name: 'ultimo_faturamento.f',
    column: 'ultimo_faturamento',
    label: 'Último Faturamento Final',
    type: 'date',
  },
  {
    name: 'proximo_faturamento.i',
    column: 'proximo_faturamento',
    label: 'Próximo Faturamento Inicial',
    type: 'date',
  },
  {
    name: 'proximo_faturamento.f',
    column: 'proximo_faturamento',
    label: 'Próximo Faturamento Final',
    type: 'date',
  },
];

export default getContratosFilterFields;
